import {DatePicker as ArkDatePicker} from '@ark-ui/react/date-picker'
import {fromArkDatePickerContextValues} from '~/components/date_based_pickers/helpers'

/**
 * @typedef {Object} DatePickerProviderProps
 * @property {(context: import('~/components/date_based_pickers/helpers').DatePickerContextValues) => import('react').ReactNode} children
 */

/** @param {DatePickerProviderProps} props */
export const DatePickerProvider = ({children}) => {
	return <ArkDatePicker.Context>{ctx => children(fromArkDatePickerContextValues(ctx))}</ArkDatePicker.Context>
}
